import React from 'react';
import StrategyTab from './strategy-tab';

/*
 * The purpose of these wrappers is to force react-router to recognize
 * that a new component was rendered, despite it being the same functional
 * component in the DOM.	This is important for lifecycle methods that run
 * "on mount" as it pertains to the table and graph queries.
 */
const getTab = (strategyId, type, defaultDates, pastDateThreshold, futureLimit) => {
  return (
    <StrategyTab
      strategyId={strategyId}
      type={type}
      defaultDates={defaultDates}
      pastDateThreshold={pastDateThreshold}
      futureLimit={futureLimit}
    />
  );
};

function TopPublishersTab({ strategyId, type, defaultDates, pastDateThreshold, futureLimit }) {
  return getTab(strategyId, type, defaultDates, pastDateThreshold, futureLimit);
}

function TopStoriesTab({ strategyId, type, defaultDates, pastDateThreshold, futureLimit }) {
  return getTab(strategyId, type, defaultDates, pastDateThreshold, futureLimit);
}

function TopRecommendationsTab({ strategyId, type, defaultDates, pastDateThreshold, futureLimit }) {
  return getTab(strategyId, type, defaultDates, pastDateThreshold, futureLimit);
}

export { TopPublishersTab, TopStoriesTab, TopRecommendationsTab };
